import { render } from "./MyOrdersPage.vue?vue&type=template&id=36c06258"
import script from "./MyOrdersPage.vue?vue&type=script&lang=js"
export * from "./MyOrdersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__